import React, { useEffect, useRef, useState } from 'react';
import Accordion from '@mui/material/Accordion';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import css from './BookingDetailsForm.module.css';
import { AlTextField } from '../../../common/components/AlTextField';
import { ExpansionPanelSummary } from '../../../common/components/ExpansionPanelSummary';
import { PhoneField } from '../../../common/components/PhoneField';

const DifferentPassenger = ({ booking, onChange, bookingError, touchBooking }) => {
    const { t } = useTranslation();
    const firstRef = useRef(null);
    const [isExpanded, setExpanded] = useState(false);
    // Force the accordion open while the phone is invalid: the error outline must not
    // hide in the collapsed subtree when the continue button highlights + scrolls to it.
    const phoneError = bookingError('passengerPhone');

    // Persist a validation-triggered expansion: once the user fixes the number the error
    // clears, and without this the panel would collapse under the field being edited.
    useEffect(() => {
        if (phoneError) {
            setExpanded(true);
        }
    }, [phoneError]);

    useEffect(() => {
        if (!isExpanded) {
            return;
        }
        firstRef.current.focus();
    }, [isExpanded]);

    return (
        <Accordion expanded={isExpanded || Boolean(phoneError)} onChange={(_, expanded) => setExpanded(expanded)}>
            <ExpansionPanelSummary text="alternativePassenger.title" />
            <Box sx={{ p: 1 }}>
                <div className={css.row}>
                    <div className={css.item}>
                        <AlTextField
                            autoComplete="off"
                            fullWidth
                            name="passengerFirstName"
                            onChange={onChange}
                            value={booking.passengerFirstName || ''}
                            placeholder={t('first-name')}
                            alTooltip={t('tooltip.passengerFirstName')}
                            inputRef={firstRef}
                        />
                    </div>
                    <div className={css.item}>
                        <AlTextField
                            autoComplete="off"
                            fullWidth
                            name="passengerLastName"
                            onChange={onChange}
                            value={booking.passengerLastName || ''}
                            placeholder={t('last-name')}
                            alTooltip={t('tooltip.passengerLastName')}
                        />
                    </div>
                </div>
                <Box
                    sx={{
                        boxSizing: 'border-box',
                        maxWidth: {
                            xs: '100%',
                            sm: '50%',
                        },
                        paddingRight: { sm: '5px' },
                    }}
                >
                    <PhoneField
                        name="passengerPhone"
                        defaultCountry="DE"
                        placeholder={t('alternativePassenger.phone')}
                        value={booking.passengerPhone || ''}
                        onChange={onChange}
                        onBlur={touchBooking}
                        error={bookingError('passengerPhone')}
                    />
                </Box>
            </Box>
        </Accordion>
    );
};

export { DifferentPassenger };
